import api from './axios';

const BASE = '/documents/denial-analyses';

export const createDenialAnalysis = () =>
  api.post(`${BASE}/`, {});

export const getDenialAnalysis = (analysisId) =>
  api.get(`${BASE}/${analysisId}/`);

export const listDenialAnalyses = (params = {}) =>
  api.get(`${BASE}/`, { params });

export const deleteDenialAnalysis = (analysisId) =>
  api.delete(`${BASE}/${analysisId}/`);

export const uploadDenialDocument = (analysisId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`${BASE}/${analysisId}/uploads/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const triggerOcrExtraction = (analysisId, force = false) =>
  api.post(`${BASE}/${analysisId}/extract/`, { force });

export const submitAnalysis = (analysisId) =>
  api.post(`${BASE}/${analysisId}/analyze/`, {});

export const getDenialAnalysisResult = (analysisId) =>
  api.get(`${BASE}/${analysisId}/result/`);

export const createDenialAnalysisFromAppeal = (appealId) =>
  api.post(`/documents/denial-analyses/from-appeal/${appealId}/`, {});
